import React, { useState } from "react";
import "./Adminsubscription.css";
 import POSBillingManagement from './POSBillingManagement'
 import Userregistration from './Userregistration';
 import TermsAndConditions from './TermsAndConditions';
 import RefundCancellation from './RefundCancellation';
import Adminsummery from './Adminsummery';
/* ---------- Dummy Section Component ---------- */
const DummySection = ({ title }) => {
  return (
    <div className="dummy-box">
      <h2>{title}</h2>
      <p>This is a dummy section for <strong>{title}</strong>.</p>
      <span>Content will be added later 🚧</span>
    </div>
  );
};

/* ---------- Main Company Component ---------- */
const Company = () => {
  const tabs = [
  { id: 1, name: "POS BILLING MANAGEMENT", component: () => <POSBillingManagement title="About Us" /> },
  { id: 2, name: "USER REGISTRATION", component: () => <Userregistration onNext={()=>setActiveTab(3)} title="Company Structure" /> },
  { 
    id: 3, 
    name: "TERMS & POLICIES", 
    component: () => <TermsAndConditions onNext={() => setActiveTab(4)} /> // <-- NEXT switches tab
  },
  { id: 4, name: "REFUND & CANCELLATION", component: () => <RefundCancellation title="Attendance Management" /> },
  { id: 5, name: "SUBSCRIPTION OVERVIEW", component: () => <Adminsummery title="Leave Management" /> },
];

  const [activeTab, setActiveTab] = useState(tabs[0].id);
  const ActiveComponent = tabs.find(tab => tab.id === activeTab)?.component;

  return (
    <div className="company-container">

      {/* 🔹 Inline CSS */}
      <style>{`
  /* Default (Mobile first) – kuch change nahi */
  .company-scroll-container {
    position: static;
    background: #fff;
  }

  .company-buttons-row {
    display: flex;
    // gap: 10px;
    flex-wrap: wrap;
  }

  .company-button {
    padding: 8px 16px;
    border: none;
    background: #f0f0f0;
    cursor: pointer;
    border-radius: 6px;
    white-space: nowrap;
  }

  .company-button.active {
    background: #7564e6;
    color: #fff;
  }

  /* ✅ Desktop / Laptop only */
  @media (min-width: 769px) {
    .company-scroll-container {
      position: sticky;
      top: 0;
      z-index: 100;
      padding: 10px 0;
    }
  }
`}</style>


      {/* Tabs */}
      <div className="company-scroll-container">
        <div className="company-buttons-row">
          {tabs.map(tab => (
            <button
              key={tab.id}
              className={`company-button ${activeTab === tab.id ? "active" : ""}`}
              onClick={() => setActiveTab(tab.id)}
            >
              {tab.name}
            </button>
          ))}
        </div>
      </div>

      {/* Active Section */}
      <div className="component-display">
        {ActiveComponent && <ActiveComponent />}
      </div>
    </div>
  );
};


export default Company;
